import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ActionOrganizationScopeDesign, ActionScope, OrganizationPotentialOwner, OrganizationLevel } from './actionOrganizationScope';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { AlternativeParticipantComponent } from '../participant/alternative-participant/alternative-participant.component';
import { OrganizationParticipantExpression } from '../../domain/entities/organization-participant-expression';
import { Participant, ParticipantInfo } from '../participant/participant.info';
import { MessagerService } from '@farris/ui-messager';

@Component({
  selector: 'app-organization-potential-owner',
  templateUrl: './organization-potential-owner.component.html',
  styleUrls: ['./organization-potential-owner.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class OrganizationPotentialOwnerComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input() editorParams: any = {};

  @ViewChild(AlternativeParticipantComponent) alternativeParticipant: AlternativeParticipantComponent;

  @Input()
  set value(v: ActionOrganizationScopeDesign) {
    this.action = v.action as any;
    if (this.action === this.actionCollection[2].value) {
      if (v.enable === null || v.enable === undefined) {
        this.enable = true;
      } else {
        this.enable = v.enable;
      }
    } else {
      this.enable = v.enable;
    }
    if (v.scope) {
      this.alternativeParticipant.participant.isAllScope = true;
      let organizationParticipantExpression = new OrganizationParticipantExpression();
      organizationParticipantExpression.actionScope = v.action as any;
      if (v.scope.organizationLevel === OrganizationLevel.DEFAULT && v.scope.tag === 'expression') {
        organizationParticipantExpression.organizationLevel = OrganizationLevel.VARORGANIZATION;
        organizationParticipantExpression.tag = v.scope.tag;
        this.organizationLevel = OrganizationLevel.VARORGANIZATION;
      } else if(v.scope.organizationLevel){
        this.organizationLevel = v.scope.organizationLevel;
      }
      this.includeChildren = v.scope.includeChildren;
      organizationParticipantExpression.includeChildren = v.scope.includeChildren;
      this.organizationId = v.scope.organizationId;
      organizationParticipantExpression.organizationId = v.scope.organizationId;
      organizationParticipantExpression.organizationName = this.organizationLevelCollection.find(o => o.value === this.organizationLevel).text;
      this.alternativeParticipant.addOrganizationParticipant(organizationParticipantExpression);
      if(v.scope.participantInfo){
        this.alternativeParticipant.participant = v.scope.participantInfo;
      }else {
        this.alternativeParticipant.participant = new ParticipantInfo();
      }
    }else {
      this.alternativeParticipant.participant.isAllScope = false;
    }
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  organizationLevelCollection = [{
    value: 'GLOBAL',
    text: this.localePipe.transform('component.orgPotentialOwner.global'),
    orgId: 'global',
  }, {
    value: 'UNIT',
    text: this.localePipe.transform('component.orgPotentialOwner.currentUnit'),
    orgId: 'currentUnit'
  }, {
    value: 'DEPARTMENT',
    text: this.localePipe.transform('component.orgPotentialOwner.currentDepartment'),
    orgId: 'currentDepartment'
  },
  {
    value: 'VARORGANIZATION',
    text: this.localePipe.transform('component.orgPotentialOwner.variableOrganization'),
    orgId: ''
  }];
  actionCollection = [{
      value: ActionScope.AddSignBehind, name: this.localePipe.transform('component.orgPotentialOwner.addSignBehind')
  }, {
      value: ActionScope.AddSignFront, name: this.localePipe.transform('component.orgPotentialOwner.addSignFront')
  }, {
      value: ActionScope.Transfer, name: this.localePipe.transform('component.orgPotentialOwner.transfer')
  }, {
    value: ActionScope.Notify, name: this.localePipe.transform('component.orgPotentialOwner.notify')
}];
  enable = false;
  organizationLevel = this.organizationLevelCollection[0].value;
  action = this.actionCollection[0].value;
  includeChildren = false;
  organizationId = '';
  showClearButton = false;

  constructor(
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private expr: ExpressionService,
    private message: MessagerService,
    private designerUIState: ProcessDesignerUIState
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  clickOK() {
    if(this.validate()){
      const scope = new ActionOrganizationScopeDesign();
      scope.enable = this.enable;
      scope.action = this.action as any;
      if (this.alternativeParticipant.participant.isAllScope) {
        const potential = new OrganizationPotentialOwner();
        potential.actionScope = this.action;
        // potential.organizationLevel = this.organizationLevel as OrganizationLevel;
        // potential.organizationId = this.organizationLevelCollection.find(o => o.value === this.organizationLevel).orgId || this.organizationId;
        // potential.organizationName = this.organizationLevelCollection.find(o => o.value === this.organizationLevel).text;
        // potential.includeChildren = this.includeChildren;
        // if (potential.organizationLevel === OrganizationLevel.VARORGANIZATION) {
        //   potential.tag = 'expression';
        //   potential.organizationLevel = OrganizationLevel.DEFAULT;
        // } else {
        //   potential.tag = 'variable';
        // }
        scope.scope = potential as any;
        scope.scope.participantInfo = this.alternativeParticipant.participant;
      }
      const object = { value: scope, parameters: null };
      this.submitModal.emit(object);
    }
  }
  clickCancel() {
    this.closeModal.emit();
  }

  validate() {
    if(this.alternativeParticipant.participant.isAllScope && 
      (!this.alternativeParticipant.participant.potentialOwnerList || this.alternativeParticipant.participant.potentialOwnerList.length <= 0)) {
        this.message.info(this.localePipe.transform('component.orgPotentialOwner.turnOffPrompt'));
        return false;
      }else {
        return true;
      }
  }
  valueChange(event: any) {
    switch (event.value) {
      case this.organizationLevelCollection[0].value:
        this.includeChildren = false;
        break;
      case this.organizationLevelCollection[1].value:
        this.includeChildren = true;
        break;
      case this.organizationLevelCollection[2].value:
        this.includeChildren = false;
        break;
      case this.organizationLevelCollection[3].value:
        this.includeChildren = true;
        this.organizationId = '';
        break;
    }
  }
  actionName = () => {
    return this.actionCollection.find(a => a.value === this.action).name;
  }
  clear($event) {
    this.organizationId = '';
  }
  selectValue(data: any) {
    this.showExprHelp();
  }

  showExprHelp() {
    const context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced);
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    // 预置表达式展示文本
    if (this.organizationId) {
      this.expr.addExpressionText(this.organizationId);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressioninfo: string) => {
      if (expressioninfo) {
        this.organizationId = expressioninfo;
        this.organizationLevelCollection[3].orgId = expressioninfo;
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  modalConfig = {
    title: this.localePipe.transform('component.orgPotentialOwner.optionSettings'),
    width: 760,
    height: 506,
    showButtons: true
  };
}
export class OrganizationPotentialOwnerConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: ActionOrganizationScopeDesign): string {
    if (data && data.action === ActionScope.Transfer as any && (data.enable === null || data.enable === undefined)) {
      return this.localePipe.transform("component.orgPotentialOwner.set");
    } else {
      if (data && data.enable) {
        return this.localePipe.transform("component.orgPotentialOwner.set");
      } else {
        return this.localePipe.transform("component.orgPotentialOwner.notSet");
      }
    }
  }
}
